export function replenishmentReportHref(
  warehouseHref: string,
  locationId: string | null,
): string {
  const params = new URLSearchParams();
  if (locationId) {
    params.set("crdbLocationId", locationId);
  }
  const query = params.toString();
  return `${warehouseHref}/replenishment/report${query ? `?${query}` : ""}`;
}
